"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _Header = _interopRequireDefault(require("../Header/Header"));

var _Table = require("./Table.style");

var _propTypes2 = require("../propTypes");

var _NoData = _interopRequireDefault(require("../NoData/NoData"));

var _Row = _interopRequireDefault(require("../Row/Row"));

var _TableBody = _interopRequireDefault(require("../TableBody/TableBody"));

var Table =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Table, _Component);

  function Table() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Table)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleScrollForFixedHeader", function () {
      var header = document.querySelectorAll('.table-header');

      if (header && header[0]) {
        var height = document.querySelectorAll('header table')[0] && document.querySelectorAll('header table')[0].offsetHeight;
        var threshold = parseFloat(_this.props.top);

        if (header[0].getBoundingClientRect().y < -height + threshold) {
          var a = document.querySelectorAll('.table-header-fixed');
          a.forEach(function (item) {
            item.style.transform = "translate3d(0, ".concat(_this.props.top, ", 0)");
          });
        } else {
          var _a = document.querySelectorAll('.table-header-fixed');

          _a.forEach(function (item) {
            item.style.transform = 'translate3d(0, -100vh, 0)';
          });
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderRow", function (rowData, index, indentLevel, rowExpandOptions) {
      var columnManager = _this.context.columnManager;
      var _this$props = _this.props,
          onRowClick = _this$props.onRowClick,
          rowHeight = _this$props.rowHeight,
          handleRowHover = _this$props.handleRowHover,
          hoveredRowKey = _this$props.hoveredRowKey,
          isAnyRowExpandable = _this$props.isAnyRowExpandable,
          draggable = _this$props.draggable,
          setIcon = _this$props.setIcon,
          tableType = _this$props.tableType;
      var leafColumns;

      if (tableType === 'left') {
        leafColumns = columnManager.leftLeafColumns();
      } else if (tableType === 'right') {
        leafColumns = columnManager.rightLeafColumns();
      } else {
        leafColumns = columnManager.leafColumns();
      }

      return _react.default.createElement(_Row.default, (0, _extends2.default)({
        rowData: rowData,
        rowIndex: index,
        columns: leafColumns,
        key: rowData.__key,
        onRowClick: onRowClick,
        onDrop: function onDrop(dragIndex, hoverIndex, dropped) {
          return _this.onDrop(dragIndex, hoverIndex, dropped);
        },
        rowHeight: rowHeight,
        handleRowHover: handleRowHover,
        isHovered: hoveredRowKey === rowData.__key,
        indentLevel: indentLevel,
        isAnyRowExpandable: isAnyRowExpandable,
        draggable: draggable,
        setIcon: setIcon
      }, rowExpandOptions));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onDrop", function (dragIndex, hoverIndex, dropped) {
      var onDrop = _this.props.onDrop;
      onDrop(dragIndex, hoverIndex, dropped);
    });
    return _this;
  }

  (0, _createClass2.default)(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.fixedHeader) {
        window.addEventListener('scroll', this.handleScrollForFixedHeader);
        var allTables = document.querySelectorAll('.table-section');
        var maxWidth = 0;
        allTables.forEach(function (item) {
          if (item.offsetWidth > maxWidth) {
            maxWidth = item.offsetWidth;
          }
        });
        var fixedHeaders = document.querySelectorAll('.table-header-fixed');

        if (fixedHeaders) {
          fixedHeaders.forEach(function (item) {
            item.style.maxWidth = maxWidth + 'px';
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.fixedHeader) {
        window.removeEventListener('scroll', this.handleScrollForFixedHeader);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var columnManager = this.context.columnManager;
      var _this$props2 = this.props,
          data = _this$props2.data,
          loading = _this$props2.loading,
          showHeader = _this$props2.showHeader,
          fixedHeader = _this$props2.fixedHeader,
          emptyConfig = _this$props2.emptyConfig,
          wrapperStyle = _this$props2.wrapperStyle,
          hasFixed = _this$props2.hasFixed,
          handleRowHover = _this$props2.handleRowHover,
          primaryTableClassName = _this$props2.primaryTableClassName,
          onExpandRow = _this$props2.onExpandRow,
          draggable = _this$props2.draggable,
          headerClass = _this$props2.headerClass,
          tableType = _this$props2.tableType,
          expandedKeys = _this$props2.expandedKeys;
      var leafColumns;

      if (tableType === 'left') {
        leafColumns = columnManager.leftLeafColumns();
      } else if (tableType === 'right') {
        leafColumns = columnManager.rightLeafColumns();
      } else {
        leafColumns = columnManager.leafColumns();
      }

      return _react.default.createElement("section", {
        className: (0, _classnames.default)(wrapperStyle, 'table-section')
      }, showHeader && fixedHeader && _react.default.createElement("header", {
        className: (0, _classnames.default)((0, _Table.scrollableHeader)(hasFixed || fixedHeader), headerClass, 'table-header-fixed')
      }, _react.default.createElement("table", {
        className: (0, _Table.tableCommonStyles)(loading, hasFixed, tableType)
      }, _react.default.createElement(_Header.default, this.props))), _react.default.createElement("main", {
        className: (0, _classnames.default)((0, _Table.bodyWrapper)(fixedHeader))
      }, _react.default.createElement("table", {
        className: (0, _classnames.default)((0, _Table.tableCommonStyles)(loading, hasFixed, tableType), primaryTableClassName, 'table-header', "table-".concat(tableType))
      }, showHeader && _react.default.createElement(_Header.default, this.props), _react.default.createElement("tbody", {
        onMouseLeave: function onMouseLeave() {
          return handleRowHover(null);
        }
      }, (0, _isEmpty.default)(data) ? _react.default.createElement(_NoData.default, (0, _extends2.default)({}, emptyConfig, {
        colSpan: leafColumns.length
      })) : _react.default.createElement(_TableBody.default, {
        indentLevel: 0,
        data: data,
        renderRow: this.renderRow,
        onExpandRow: onExpandRow,
        draggable: draggable,
        expandedKeys: expandedKeys
      })))));
    }
  }]);
  return Table;
}(_react.Component);

(0, _defineProperty2.default)(Table, "contextTypes", {
  columnManager: _propTypes.default.any.isRequired
});
Table.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes2.rowPropType).isRequired,
  onRowClick: _propTypes.default.func,
  fixedHeader: _propTypes.default.bool.isRequired,
  maxBodyHeight: _propTypes.default.string.isRequired,
  showHeader: _propTypes.default.bool.isRequired,
  loading: _propTypes.default.bool.isRequired,
  emptyConfig: _propTypes.default.shape({
    label: _propTypes.default.string,
    button: _propTypes.default.shape({})
  }).isRequired,
  rowHeight: _propTypes.default.number,
  handleRowHover: _propTypes.default.func.isRequired,
  hoveredRowKey: _propTypes.default.string,
  wrapperStyle: _propTypes.default.string.isRequired,
  hasFixed: _propTypes.default.bool.isRequired,
  primaryTableClassName: _propTypes.default.string,
  isAnyRowExpandable: _propTypes.default.bool.isRequired,
  onExpandRow: _propTypes.default.func.isRequired,
  draggable: _propTypes.default.bool.isRequired,
  tableType: _propTypes.default.oneOf(['left', 'main', 'right']).isRequired
};
var _default = Table;
exports.default = _default;